import { periodicReportsRepo } from "./periodicReports.repo";
import {
  IIzvestajiIsporuceneMarkicePayload,
  PeriodicReportListFilterPayload,
} from "./periodicReports.types";

class PeriodicReportsService {
  createIzvestajiIsporuceneMarkice = (
    payload: IIzvestajiIsporuceneMarkicePayload
  ) => {
    return periodicReportsRepo.createIzvestajiIsporuceneMarkice(payload);
  };

  generatePeriodicReport = () => {
    return periodicReportsRepo.generatePeriodicReport();
  };

  getPeriodicReportList = (
    payload?: Partial<PeriodicReportListFilterPayload>
  ) => {
    return periodicReportsRepo.getPeriodicReportList(payload);
  };
}

export const periodicReportsService = new PeriodicReportsService();
